/**
 * Pathname chokepoint — always the browser location pathname (may include trailing slash).
 * Callers should normalize with normalizeApplicationPathname for route keys.
 */

import { useLocation } from "react-router";

export function useAppPathname(): string {
  return useLocation().pathname;
}
